/* section-shop-the-look-v2.js */
(() => {
  'use strict';

  function getRoutesRoot() {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';

    return root.endsWith('/') ? root : `${root}/`;
  }

  function getCartAddUrl() {
    if (window.routes && typeof window.routes.cart_add_url === 'string') {
      return window.routes.cart_add_url;
    }
    return `${getRoutesRoot()}cart/add.js`;
  }

  function initShopTheLook(root) {
    if (!root) return;

    // Evita doble inicialización
    if (root.dataset.stlInitialized === 'true') return;
    root.dataset.stlInitialized = 'true';

    const slides = Array.from(root.querySelectorAll('[data-stl-slide]'));
    const pins = Array.from(root.querySelectorAll('[data-stl-pin]'));
    const dots = Array.from(root.querySelectorAll('[data-stl-dot]'));

    const prevBtns = Array.from(root.querySelectorAll('[data-stl-prev]'));
    const nextBtns = Array.from(root.querySelectorAll('[data-stl-next]'));
    const buyAllBtn = root.querySelector('[data-stl-buy-all]');

    const total = slides.length;
    if (!total) return;

    let current = 0;

    function setActive(index) {
      if (!total) return;

      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;

      slides.forEach((slide, i) => {
        const isActive = i === current;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      pins.forEach((pin) => {
        const i = Number(pin.dataset.stlPinIndex || 0);
        pin.classList.toggle('is-active', i === current);
      });

      dots.forEach((dot) => {
        const i = Number(dot.dataset.stlIndex || 0);
        const isActive = i === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    pins.forEach((pin) => {
      pin.addEventListener('click', () => {
        const index = Number(pin.dataset.stlPinIndex || 0);
        setActive(index);
      });
    });

    prevBtns.forEach((btn) => btn.addEventListener('click', () => setActive(current - 1)));
    nextBtns.forEach((btn) => btn.addEventListener('click', () => setActive(current + 1)));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.stlIndex || 0);
        setActive(index);
      });
    });

    if (buyAllBtn) {
      buyAllBtn.addEventListener('click', async () => {
        const csv = buyAllBtn.dataset.variants || '';
        const ids = csv
          .split(',')
          .map((v) => v.trim())
          .filter(Boolean);

        if (!ids.length) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const cart = cartDrawer || cartNotification;

        const formData = new FormData();

        ids.forEach((id, index) => {
          formData.append(`items[${index}][id]`, id);
          formData.append(`items[${index}][quantity]`, '1');
        });

        if (cart && typeof cart.getSectionsToRender === 'function') {
          const sectionIds = cart
            .getSectionsToRender()
            .map((s) => s.id)
            .filter(Boolean);

          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);

          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }

        buyAllBtn.classList.add('loading');
        buyAllBtn.setAttribute('aria-busy', 'true');
        buyAllBtn.disabled = true;

        try {
          const res = await fetch(getCartAddUrl(), {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
            },
            body: formData,
            credentials: 'same-origin',
          });

          const data = await res.json();
          if (!res.ok) throw data;

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            const inner = cartDrawer.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');

            cartDrawer.renderContents(data);
          } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
            cartNotification.renderContents(data);
          } else {
            window.location.href = `${getRoutesRoot()}cart`;
          }
        } catch (err) {
          console.error('[ShopTheLookV2] Buy all error', err);
        } finally {
          buyAllBtn.classList.remove('loading');
          buyAllBtn.removeAttribute('aria-busy');
          buyAllBtn.disabled = false;
        }
      });
    }

    setActive(0);
  }

  function initAll(ctx = document) {
    ctx.querySelectorAll('[data-shop-the-look-v2]').forEach(initShopTheLook);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
